import { createRoutedApp } from '@kanda-libs/ks-frontend-services';

import { ToolkitStore } from '@reduxjs/toolkit/dist/configureStore';
import { PageKeys, URLS } from 'config';
import { useViewportVariables } from 'hooks/useViewportVariables';
import Pages from 'pages';
import { FunctionComponent } from 'react';
import { Redirect } from 'react-router-dom';
import { RootState, store } from 'store';
import AppWrapper from '../AppWrapper';
import BannerWrapper from '../BannerWrapper';
import { ENQUIRY_INITIAL_ACTIONS } from './constants';

const {
  pages,
  router: { Router },
} = createRoutedApp<RootState, PageKeys>(
  store as unknown as ToolkitStore<RootState>,
  {
    customCode: {
      path: URLS.customCode,
      PageComponent: Pages.CustomCode,
      loadingDependencies: [],
      initialDataActions: [],
    },
    staffLogin: {
      path: URLS.staffLogin,
      PageComponent: Pages.StaffLogin,
      requiredRoles: [],
      loadingDependencies: [],
      initialDataActions: [],
    },
    staff: {
      path: URLS.staff,
      PageComponent: Pages.Staff,
      requiredRoles: ['staff'],
      loadingDependencies: [],
      initialDataActions: [],
    },
    logout: {
      path: URLS.logout,
      PageComponent: Pages.Logout,
      requiredRoles: [],
      loadingDependencies: [],
      initialDataActions: [],
    },
    enquiryQuoteComplete: {
      path: URLS.enquiryQuoteComplete,
      ...ENQUIRY_INITIAL_ACTIONS,
    },
    enquiryQuoteConfirmDetails: {
      path: URLS.enquiryQuoteConfirmDetails,
      ...ENQUIRY_INITIAL_ACTIONS,
    },
    enquiryQuoteUploadQuote: {
      path: URLS.enquiryQuoteUploadQuote,
      ...ENQUIRY_INITIAL_ACTIONS,
    },
    enquiryQuoteContactDetails: {
      path: URLS.enquiryQuoteContactDetails,
      ...ENQUIRY_INITIAL_ACTIONS,
    },
    enquiryQuoteWelcome: {
      path: URLS.enquiryQuoteWelcome,
      ...ENQUIRY_INITIAL_ACTIONS,
    },
    enquiryComplete: {
      path: URLS.enquiryComplete,
      ...ENQUIRY_INITIAL_ACTIONS,
    },
    enquiryProjectBudget: {
      path: URLS.enquiryProjectBudget,
      ...ENQUIRY_INITIAL_ACTIONS,
    },
    enquiryWorkDetails: {
      path: URLS.enquiryWorkDetails,
      ...ENQUIRY_INITIAL_ACTIONS,
    },
    enquiryContactDetails: {
      path: URLS.enquiryContactDetails,
      ...ENQUIRY_INITIAL_ACTIONS,
    },
    enquiryWelcome: {
      path: URLS.enquiryWelcome,
      ...ENQUIRY_INITIAL_ACTIONS,
    },
    enquiry: {
      path: URLS.enquiry,
      ...ENQUIRY_INITIAL_ACTIONS,
    },
    shortUrl: {
      path: URLS.shortUrl,
      PageComponent: Pages.ShortUrl,
      requiredRoles: [],
      loadingDependencies: [],
      initialDataActions: [],
    },
    home: {
      path: URLS.home,
      PageComponent: Pages.Home,
      requiredRoles: [],
      loadingDependencies: [],
      initialDataActions: [],
    },
  },
  () => <Redirect to={URLS.home} />,
  BannerWrapper,
  URLS.home,
);

export { pages };

const App: FunctionComponent = function () {
  useViewportVariables();
  return (
    <AppWrapper>
      <Router />
    </AppWrapper>
  );
};

export default App;
